import { DeckTransitionProps } from 'components/maps/MapContext/MapContext';
import { uniqueId } from 'lodash';
import { useEffect, useRef } from 'react';
import { ViewState } from 'react-map-gl/dist/esm/types';

export const useDebugMap = ({
  viewState,
}: {
  viewState: Partial<ViewState> & DeckTransitionProps;
}) => {
  const DEBUG_MAP_ID = useRef(uniqueId('DEBUG_MAP__'));

  const { bearing, latitude, longitude, zoom, pitch } = viewState;
  useEffect(() => {
    if (!(window as any).DEBUG_MAP) {
      (window as any).DEBUG_MAP = {};
    }
    (window as any).DEBUG_MAP[DEBUG_MAP_ID.current] = {
      bearing,
      latitude,
      longitude,
      zoom,
      pitch,
    };

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      delete (window as any).DEBUG_MAP[DEBUG_MAP_ID.current];
    };
  }, [bearing, latitude, longitude, zoom, pitch]);

  return { DEBUG_MAP_ID: DEBUG_MAP_ID.current };
};
